import {
  Component,
  OnInit,
  Input,
  ComponentFactoryResolver,
  ElementRef,
  AfterViewInit,
  ViewChild,
  HostListener,
  ChangeDetectorRef
} from '@angular/core';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { SignatureDataEntity } from 'src/app/models/data-entities/signature-data-entity';
import { UntypedFormBuilder, NgForm, Validators } from '@angular/forms';
import { SignatureFieldComponent } from '../signature-field/signature-field.component';
import SignaturePad, { PointGroup } from 'signature_pad';
import { isArray } from 'jquery';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-signature-data-entity-input',
    templateUrl: './signature-data-entity-input.component.html',
    styleUrls: ['./signature-data-entity-input.component.css'],
    standalone: false
})
export class SignatureDataEntityInputComponent extends DataEntityInputComponent
  implements OnInit, AfterViewInit {
  @Input() entity: SignatureDataEntity;
  @ViewChild(SignatureFieldComponent, { static: false })
  public sig: SignatureFieldComponent;
  @ViewChild('sigContainer1') public sigContainer1: ElementRef;
  templateForPermitForm:boolean=false
  printedName: string = '';

  hasPath: boolean = false;
  imagePath: string = '';

  constructor(
    public layoutService: LayoutService,
    componentFactoryResolver: ComponentFactoryResolver,
    private ref: ChangeDetectorRef,
    private _fb: UntypedFormBuilder,
    context : WorkflowContextService  
  ) {
    super(layoutService, componentFactoryResolver, ref, context);
          //added by priya 19-12-2025

       layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
          //end by priya 19-12-2025

  }
  onFormSubmit(form: NgForm) { }

  ngOnInit() {
    if (!this.form.contains(this.entity.templateCode)) {
      this.form.addControl(
        this.entity.templateCode,
        this._fb.control(this.entity.value ?? null, [Validators.nullValidator])
      );
    }

    if (this.entity.includePrintedName) {
      if (!this.form.contains(this.entity.templateCode + '_PrintedName'))  {
        const validators = this.entity.isRequired ? [Validators.required] : [Validators.nullValidator];

        this.form.addControl(
          this.entity.templateCode + '_PrintedName',
          this._fb.control(this.printedName, validators)
        );
      }
    }
  }


  cancelCalculation() {
    if (!this.hasPath) {
      setTimeout(() => {
        this.beResponsive();
        this.sig.signaturePad.fromData(this.sig.signaturePad.toData());
      }, 100);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (!this.hasPath) {
      this.beResponsive();
      this.sig.signaturePad.fromData(this.sig.signaturePad.toData());
    }
  }

  private parseEntityValue() {
    let parsedValue = null;
    try {
      if (typeof this.entity.value === 'string') {
        parsedValue = JSON.parse(this.entity.value);
      } else {
        parsedValue = this.entity.value;
      }
    } catch {
      // do nothing
      console.log('Entity Value: ', this.entity.value);
    }

    if (parsedValue && parsedValue.path) {
      this.hasPath = true;
      this.imagePath = parsedValue.path;
    } else {
      this.hasPath = false;
      this.imagePath = '';
    }
  }

  public ngAfterViewInit() {
    // Check if entity has a path before initializing signature pad
    this.parseEntityValue();

    if (!this.hasPath) {
      this.setOptions();
    }

    // this is here to let the parent resize before we resize the canvas for the signature in modal dialogs.
    setTimeout(() => {
      if (!this.hasPath) {
        this.beResponsive();
      }

      if ((this.entity.value || '') !== '') {
        let value: { 
          data: PointGroup[]; 
          image: string;
          path: string;
          printedName?: string;
        };

        let parsedValue = null;

        try {
          parsedValue = JSON.parse(this.entity.value as string);
        }
        catch {
          // do nothing
        }

        if (parsedValue) {
          // I can't determine how the value gets this way, but it could appear as {"data":null,"image":""}
          // If that's the case, treat it the same as a null value would be treated.
          if ((parsedValue.data !== null) && (parsedValue.image !== '')) {
            if (parsedValue.data) {
              if (parsedValue.data.indexOf('lx') > -1) {
                parsedValue.data = parsedValue.data
                  .replaceAll('lx', 'x')
                  .replaceAll('ly', 'y');
                parsedValue.data = `[` + parsedValue.data + `]`;
              } else {
                parsedValue = JSON.parse(this.entity.value as string);
              }

              value = parsedValue;
            }

            if (typeof parsedValue.data === 'string') {
              parsedValue.data = JSON.parse(parsedValue.data as string);
            }
          }
          else {
            value = this.entity.value;
          }

          let newData = [];

          //
          /*
            old structure looks like this
            [
              [ // point group
                {
                  "x": 174,
                  "y": 51.6666259765625,
                  "time": 1710160764688,
                  "color": "rgb(255, 0, 0)",
                  "$id": "52"
                },
                {
                  "x": 174,
                  "y": 51.6666259765625,
                  "time": 1710160764688,
                  "color": "rgb(255, 0, 0)",
                  "$id": "52"
                }
              ],
              [ // point group
                {
                  "x": 174,
                  "y": 51.6666259765625,
                  "time": 1710160764688,
                  "color": "rgb(255, 0, 0)",
                  "$id": "52"
                },
                {
                  "x": 174,
                  "y": 51.6666259765625,
                  "time": 1710160764688,
                  "color": "rgb(255, 0, 0)",
                  "$id": "52"
                }
              ]
            ]
            new structure should look like this
            [
              {
                  points:[]
              },
              {
                points: []
              }
            ]
          */
          // check to see if data is an array
          if (isArray(value.data)) {
            if (value.data.length > 0) {
              if (isArray(value.data[0])) {
                for (let pgIdx = 0; pgIdx < value.data.length; pgIdx++) {
                  // add point group to new Data with value as points property
                  newData.push({
                    penColor: 'rgb(255, 0, 0)',
                    dotSize: 0,
                    minWidth: 0.5,
                    maxWidth: 2.5,
                    velocityFilterWeight: 0.7,
                    points: value.data[pgIdx]
                  });
                }
              } else {
                newData = value.data;
              }
            }
          }

          if (value && value.data && !this.hasPath) {
            this.sig.signaturePad.fromData(newData);

            // Added to fix re-validation issue on permit forms when navigating back to a saved signature.
            // Push the existing entity value into the form control and mark it dirty/touched so
            // Validators.required no longer flags it as empty on the next submit.
              const control = this.form.get(this.entity.templateCode);
              if (control) {
                control.setValue(this.entity.value, { emitEvent: false });
                control.markAsDirty();
                control.markAsTouched();
                control.updateValueAndValidity();
                this.ref.detectChanges();
              }
            // }
          }

          // this.form.controls[this.entity.templateCode].setValue(
          //   this.entity.value
          // );

          if (this.entity.includePrintedName && value?.printedName) {
            this.printedName = value.printedName;
            this.form.controls[this.entity.templateCode + '_PrintedName']?.setValue(value.printedName);
          }
        }
      }
    }, 100);
  }

  // set the dimensions of the signature pad canvas
  public beResponsive() {
    this.size(this.sigContainer1, this.sig);
  }

  public size(container: ElementRef, sig: SignatureFieldComponent) {
    sig.signaturePad.set('canvasWidth', container.nativeElement.clientWidth);
  }

  public setOptions() {
    this.sig.signaturePad.set('penColor', 'rgb(255, 0, 0)');
    this.sig.signaturePad.set('backgroundColor', 'rgba(0, 0, 0, 0)');
  }

  public clear() {
    this.sig.clear();
    this.entity.value = null;
    // this.form.controls[this.entity.templateCode].setValue(null);
  }
// this function no longer used. (Aavesh 08-01-2026)
  // public finishedSigning(data: SignaturePad) {
  //   this.entity.value = {
  //     image: data.toDataURL('image/png', 1),
  //     data: data.toData()
  //   };
  //   this.form.controls[this.entity.templateCode].setValue(this.entity.value);
  // }
  // Added by Vipul on 14-01-2026
  public onSignatureValueChange(value: string): void {
    // The signature-field emits a JSON string containing only { image, data }.
    // Preserve any previously entered printedName so it isn't lost when the
    // user re-draws (or draws after typing the printed name).
    this.entity.value = this.mergePrintedNameIntoValue(value, this.printedName);

    const control = this.form.get(this.entity.templateCode);
    if (control && control.value !== this.entity.value) {
      control.setValue(this.entity.value, { emitEvent: false });
    }
  }

  // End by Vipul on 14-01-2026

  public onPrintedNameChange(value: string) {
    this.printedName = value;
    // entity.value is a JSON string (produced by signature-field), not an object,
    // so parse it, inject printedName, and re-stringify so ProcessActivity carries
    // the printedName up to the server.
    this.entity.value = this.mergePrintedNameIntoValue(this.entity.value, value);

    const sigControl = this.form.get(this.entity.templateCode);
    if (sigControl && sigControl.value !== this.entity.value) {
      sigControl.setValue(this.entity.value, { emitEvent: false });
    }

    this.form.controls[this.entity.templateCode + '_PrintedName']?.setValue(value);
  }

  private mergePrintedNameIntoValue(currentValue: any, printedName: string): any {
    let parsed: any = null;

    if (currentValue != null && currentValue !== '') {
      if (typeof currentValue === 'string') {
        try {
          parsed = JSON.parse(currentValue);
        } catch {
          parsed = null;
        }
      } else if (typeof currentValue === 'object') {
        parsed = currentValue;
      }
    }

    if (!parsed) {
      parsed = {};
    }

    parsed.printedName = printedName;

    return JSON.stringify(parsed);
  }
}
